import Image from "next/image";
import React, { useEffect, useState } from "react";
import styles from "./ExistingUserLayout.module.css";

const ExistingUserLayoutHeader = ({ isVineCrm }: any) => {
  const [isMobile, setIsMobile] = useState(false);
  const [userDetails, setUserDetails] = useState<any>();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("formData");
    if (userData) {
      setUserDetails(JSON.parse(userData));
    }
  }, []);

  return (
    <>
      <div className={styles.Header}>
        <div className={`container ${styles.headContainer}`}>
          <div>
            <Image
              src={isMobile ? "/assets/regLogo.png" : "/logo_ex.png"}
              alt="logo"
              title="logo"
              width={isMobile ? 120 : 220}
              height={isMobile ? 30 : 40}
            />
          </div>
          {!isVineCrm && (
            <div className={styles.userName}>
              <span>Hi {userDetails?.name}</span>{" "}
              <span style={{ fontSize: "25px" }}>👋🏻 </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ExistingUserLayoutHeader;
